import { Accordion } from '@chakra-ui/accordion'
import { Button } from '@chakra-ui/react'
import type { FormikProps } from 'formik'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { PermissionsEnum } from '../../../utils'
import PermissionGuard from '../../components/PermissionGuard'
import {
  VideoSettingsOptimization,
  VideoSettingsSecurity,
  VideoSettingsAdvanced,
} from '../../components/Settings'
import type { SettingsResponse } from '../../interfaces'
import { MainContentHeadingBox } from '../Base/MainContent'

const VideoSettingsLayout = (
  form: FormikProps<SettingsResponse>,
): React.ReactElement => {
  const { t } = useTranslation()

  const { dirty, isSubmitting } = form

  return (
    <>
      <MainContentHeadingBox reverse={true}>
        <PermissionGuard
          permission={PermissionsEnum.SELF_IMAGE_SETTINGS_MANAGE}
        >
          {
            (hasPermission: boolean) => (
              hasPermission ? (
                <Button
                  isDisabled={!dirty}
                  isLoading={isSubmitting}
                  onClick={() => {
                    void form.submitForm()
                  }}
                >
                  {t('save')}
                </Button>
              ) : <></>
            )
          }
        </PermissionGuard>
      </MainContentHeadingBox>
      <Accordion borderColor="#9ea3ad33" allowToggle>
        <VideoSettingsOptimization {...form} />
        <VideoSettingsSecurity {...form} />
        <VideoSettingsAdvanced {...form} />
      </Accordion>
    </>
  )
}

export default VideoSettingsLayout
